import newsBanner from '@/assets/images/news/banner.png'

export const newsBannerSlides = [
  {
    id: 1,
    bgImage: newsBanner,
    alt: '元码科技 - 新闻资讯',
    imageOnly: true
  }
]

export const defaultNews = [
  {
    id: 1,
    title: '元码科技教培机构管理系统正式上线',
    category: '产品动态',
    summary: '元码科技自主研发的教培机构管理系统正式上线，为教培行业提供一站式数字化管理解决方案。',
    content: '<p>元码科技教培机构管理系统正式上线，该系统涵盖学员管理、课程排课、财务统计、家校沟通等核心功能模块。</p><p>系统采用SaaS架构，支持多校区统一管理，帮助教培机构实现降本增效、流程规范化与管理数字化升级。</p><p>目前已有多家教培机构接入使用，反馈良好。欢迎有需求的机构联系我们免费试用。</p>',
    cover: '',
    author: '元码科技',
    date: '2025-06-15',
    views: 328
  },
  {
    id: 2,
    title: '元码科技与江西耐雀无人机达成战略合作',
    category: '合作咨询',
    summary: '元码科技与江西耐雀无人机科技有限公司正式达成战略合作，共同推进无人机巡检管理系统研发。',
    content: '<p>近日，元码科技与江西耐雀无人机科技有限公司正式签署战略合作协议。</p><p>双方将在无人机巡检管理系统、AI视觉分析、数据处理等领域展开深度合作，共同推动无人机行业数字化升级。</p><p>元码科技将为耐雀无人机提供专业的软件定制开发服务，助力其在无人机巡检领域的技术创新。</p>',
    cover: '',
    author: '元码科技',
    date: '2025-05-28',
    views: 256
  },
  {
    id: 3,
    title: '在线考试系统：如何构建高效防作弊机制',
    category: '专业文章',
    summary: '深入探讨在线考试系统中防作弊机制的设计与实现，包括身份验证、行为监控、题目乱序等关键技术方案。',
    content: '<p>随着在线考试的普及，如何有效防止作弊成为系统设计的关键挑战。本文将从多个维度探讨防作弊机制的设计方案。</p><h3>一、身份验证</h3><p>采用人脸识别+身份证验证的双重身份确认机制，确保考生身份真实有效。</p><h3>二、行为监控</h3><p>通过摄像头实时监控考生行为，AI算法自动检测异常动作并告警。</p><h3>三、题目乱序</h3><p>每份试卷题目顺序随机排列，选项顺序也随机打乱，有效防止传答案。</p><h3>四、限时控制</h3><p>严格的时间限制和切屏检测，防止考生查阅外部资料。</p>',
    cover: '',
    author: '元码科技',
    date: '2025-05-10',
    views: 412
  },
  {
    id: 4,
    title: 'AI+数字化转型：企业如何借力人工智能实现提效降本',
    category: '专业文章',
    summary: '探讨人工智能技术在企业数字化转型中的应用场景，分析AI如何助力企业实现提效降本增收。',
    content: '<p>人工智能技术正在深刻改变企业的运营方式。本文将分析AI在企业数字化转型中的核心应用场景。</p><h3>智能客服</h3><p>AI客服机器人7×24小时在线，处理80%以上的常规咨询，大幅降低人力成本。</p><h3>视觉质检</h3><p>AI视觉检测替代人工质检，检测精度更高、速度更快，适用于制造业质量管控。</p><h3>数据分析</h3><p>AI驱动的商业智能分析，从海量数据中挖掘业务洞察，辅助管理决策。</p>',
    cover: '',
    author: '元码科技',
    date: '2025-04-22',
    views: 389
  },
  {
    id: 5,
    title: '元码科技德育教务文档收集评比平台获教育局认可',
    category: '产品动态',
    summary: '元码科技德育教务文档收集评比平台在多个区县教育局试点应用，获得广泛好评。',
    content: '<p>元码科技德育教务文档收集评比平台已在多个区县教育局成功试点应用。</p><p>平台支持文档在线提交、多级审核评比、结果公示等功能，大幅提升了德育工作的管理效率。</p><p>试点单位反馈，平台操作简便、流程规范，有效解决了传统纸质文档收集评比效率低、统计难的问题。</p>',
    cover: '',
    author: '元码科技',
    date: '2025-04-08',
    views: 198
  },
  {
    id: 6,
    title: '上位机软件开发：工业自动化控制的关键环节',
    category: '专业文章',
    summary: '介绍上位机软件在工业自动化控制中的作用，以及开发上位机软件需要注意的技术要点和最佳实践。',
    content: '<p>上位机软件是工业自动化控制系统中的"大脑"，负责与下位机（PLC、单片机等）通信，实现数据采集、监控和控制。</p><h3>通信协议</h3><p>支持Modbus、OPC UA、MQTT等主流工业通信协议，确保与各类设备的兼容性。</p><h3>实时性</h3><p>毫秒级数据采集和响应，满足工业控制的实时性要求。</p><h3>可靠性</h3><p>7×24小时稳定运行，具备断线重连、数据缓存等容错机制。</p><h3>可视化</h3><p>直观的组态界面，实时展示设备状态和生产数据。</p>',
    cover: '',
    author: '元码科技',
    date: '2025-03-18',
    views: 275
  }
]

export const newsCategories = ['全部', '产品动态', '合作咨询', '专业文章', '行业资讯']
